/**
 * Device Detection Utility
 * Detects device type (mobile vs desktop) using User-Agent
 */

export const isMobileDevice = () => {
    // Check if running in browser
    if (typeof window === 'undefined') return false;
    
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    // Check for mobile devices
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    
    // Additional checks
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isSmallScreen = window.innerWidth <= 768;
    
    return mobileRegex.test(userAgent) || (isTouchDevice && isSmallScreen);
};

export const isTablet = () => {
    if (typeof window === 'undefined') return false;
    
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const tabletRegex = /iPad|Android(?!.*Mobile)/i;
    
    return tabletRegex.test(userAgent);
};

export const isDesktop = () => {
    return !isMobileDevice();
};

export const getDeviceType = () => {
    if (isTablet()) return 'tablet';
    if (isMobileDevice()) return 'mobile';
    return 'desktop';
};
